/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import getPostsByType from '../../../../api/graphql/queries/getPostsByType';
import DraggableListComponent from './DraggableListComponent';
import LoadIcon from '../../../LoadIcon';
import slugify from '../../../../utils/slugify';


const Launcher2 = ({
  handlerSetComponents, components, id,
}) => {
  const initialState = {
    type: 'Launcher2',
    findCategory: [],
    slugNames: [],
    itemsProperties: {},
    quantity: 9,
    rows: 1,
    showLoadMore: false,
    mustBeSingle: false,
    isTours: false,
    isNews: false,
    showAll: false,
    hasFilters: false,
    sortByPostLauncherDate: false,
  };

  const [limit] = useState(40);
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [isLaucherBySlugNames, setLauncherBySlugNames] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);

  const getCategories = () => {
    const cats = [];
    getPostsByType('section')
      .then(({ posts }) => {
        if (posts) {
          posts.forEach(post => cats.push(slugify(post.postName)));
          cats.sort((a, b) => a - b);
          setCategories(cats);
        }
      })
      .then(() => {
        getPostsByType('sub-section')
          .then(({ posts }) => {
            if (posts) {
              posts.forEach(post => cats.push(slugify(post.postName)));
              cats.sort((a, b) => a - b);
              setCategories(cats);
            }
          });
      })
      .catch(err => console.log(err));
  };

  const setLimitHandler = (e) => {
    const { name, value } = e.target;
    const { component } = components[index];

    let data = name === 'layout' ? value : Number(value);
    if (data === 'false') data = false;

    const comp = {
      ...component,
      [name]: data,
    };
    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const toggleSwitchHandler = (e, bool) => {
    const { name } = e.target;
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: bool,
    };
    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };


  const setCategoriesHandler = (cat) => {
    const postIndex = selectedCategories.findIndex(set => set === cat);
    const componentObj = {
      id,
      component: state,
    };
    let newState = {};

    if (postIndex === -1) {
      newState = {
        ...state,
        findCategory: [...selectedCategories, cat],
      };
      setSelectedCategories([...selectedCategories, cat]);
      setState(newState);
    } else {
      const newCategories = selectedCategories;
      newCategories.splice(postIndex, 1);
      newState = {
        ...state,
        findCategory: [...newCategories],
      };
      setSelectedCategories([...newCategories]);
      setState(newState);
    }
    componentObj.component = newState;

    handlerSetComponents(componentObj, index);
  };

  const handlerSetSlugNames = (slugNames) => {
    const componentObj = {
      id,
      component: state,
    };
    const newState = {
      ...state,
      slugNames,
    };
    setState(newState);
    componentObj.component = newState;
    handlerSetComponents(componentObj, index);
  };

  const handlerSetItemsProperties = (slugName, property) => {
    const componentObj = {
      id,
      component: state,
    };

    const itemsProperties = { ...state.itemsProperties, [slugName]: property };

    const newState = {
      ...state,
      itemsProperties,
    };
    setState(newState);
    componentObj.component = newState;
    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    // Check if we are reading a component already done or if we are creating a new one
    if (component) {
      const comp = { ...component };
      if (!component.hasFilters) {
        comp.hasFilters = false;
      }
      setState(comp);
      if (component.findCategory.length) {
        setSelectedCategories(component.findCategory);
        setIsLoaded(true);
        setLauncherBySlugNames(false);
      }
    } else {
      const componentObj = {
        id,
        component: state,
      };
      handlerSetComponents(componentObj, componentIndex);
      setIsLoaded(true);
      setLauncherBySlugNames(true);
    }
  }, [components]);

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <div>
      <div className="items-center flex justify-between bg-greyFilter rounded-br-lg py-2 mb-2">
        <label htmlFor="bySlugNames" className="flex items-center pt-0 ml-4 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular">
          Launcher by category
          <label className="switch mb-0 pb-0 h-6 ml-1">
            <input
              name="isLaucherBySlugNames"
              checked={isLaucherBySlugNames}
              onChange={e => setLauncherBySlugNames(!isLaucherBySlugNames)}
              type="checkbox"
              id="switch-button"
            />
            <div className="switch-slider btn-yn switch-round" />
          </label>
        </label>
        {isLaucherBySlugNames
        && (
        <label htmlFor="bySlugNames" className="flex items-center pt-0 ml-4 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular">
          Nr of items:
          {' '}
          {state.slugNames.length > 0 ? state.slugNames.length : 'No items selected'}
        </label>
        )}
        <div className="mt-1 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-row items-center mr-10">
          Sort by Post Launcher Date?
          <label className="switch mb-0 pb-0 h-6 ml-1">
            <input
              name="sortByPostLauncherDate"
              checked={!state.sortByPostLauncherDate}
              onChange={e => toggleSwitchHandler(e, !state.sortByPostLauncherDate)}
              type="checkbox"
              id="switch-button"
            />
            <div className="switch-slider btn-yn switch-round" />
          </label>
        </div>
        <div className="mt-1 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-row items-center mr-10">
          With filter
          <label className="switch mb-0 pb-0 h-6 ml-1">
            <input
              name="hasFilters"
              checked={!state.hasFilters}
              onChange={e => toggleSwitchHandler(e, !state.hasFilters)}
              type="checkbox"
              id="switch-button"
            />
            <div className="switch-slider btn-yn switch-round" />
          </label>
        </div>
        <div className="mt-1 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-row items-center mr-10">
          Nr of displayed items:
          <select name="quantity" id="quantity" onChange={setLimitHandler} value={state.quantity} className="ml-1">
            {
              Array.from(Array(limit + 1)).map((_, ind) => (
                <option value={ind} key={ind}>
                  {' '}
                  {ind}
                  {' '}
                </option>
              ))
            }
          </select>
        </div>

      </div>
      <div>
        {!isLaucherBySlugNames
          ? (
            <div className="mr-2 rounded-lg">
              <p className="font-americaMonoBold text-xs uppercase py-1 bg-greyFilter rounded-t-lg pl-5 mt-8px mb-0">Post categories</p>
              <div className="rounded-b-lg mb-2 pt-0 overflow-auto h-32 bg-greyFilterItems pt-1 pb-1/2">
                {
                  categories.length && categories.map((category, i) => (
                    <div key={category} className="text-black text-black font-americaMonoRegular outline-none w-full pl-6 mb-0" onClick={() => setCategoriesHandler(category)}>
                      {category}
                    </div>
                  ))
                }
              </div>
              {
                selectedCategories && selectedCategories.length > 0 && (
                  <div className="text-black">
                    <p className="font-americaMonoBold text-xs text-white uppercase py-1 bg-greyFilter rounded-t-lg pl-5 mt-8px mb-0">Selected categories</p>
                    <div className="rounded-b-lg mb-2 pt-0 overflow-auto bg-greyFilterItems pt-1 pb-1/2">
                      {selectedCategories.map((category, i) => (
                        <div key={category} className="text-black text-black font-americaMonoRegular outline-none w-full pl-6 mb-0">
                          {category}
                          <span className="font-icon icon-close-btn1 pl-1 text-xs text-black" onClick={() => setCategoriesHandler(category)} />
                        </div>
                      ))}
                    </div>
                  </div>
                )
              }
            </div>
          ) : state.slugNames.length || isLoaded ? <DraggableListComponent components={state.slugNames} itemsProperties={state.itemsProperties} handlerSetComponentsInParent={handlerSetSlugNames} handlerSetItemsPropertiesInParent={handlerSetItemsProperties} /> : <LoadIcon />
              }
        <div className="flex flex-row items-center justify-between bg-greyFilter rounded-br-lg">
          {!isLaucherBySlugNames ? (
            <div className="my-2 pt-0 ml-4 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-col justify-center items-between">
              <div>
                Rows:
                <select name="rows" id="rows" onChange={setLimitHandler} value={state.rows} className="ml-1">
                  {
                    Array.from(Array(10)).map((_, ind) => (
                      <option value={ind} key={ind}>
                        {' '}
                        {ind}
                        {' '}
                      </option>
                    ))
                  }
                </select>
              </div>
            </div>
          ) : (
            <div className="my-2 pt-0 ml-4 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular">
              Rows:
              <select name="rows" id="rows" onChange={setLimitHandler} value={state.rows} className="ml-1">
                {
                    Array.from(Array(10)).map((_, ind) => (
                      <option value={ind} key={ind}>
                        {' '}
                        {ind}
                        {' '}
                      </option>
                    ))
                  }
              </select>
            </div>
          )}
          <div className="mt-1 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-col items-center">
            Load more
            <label className="switch mb-0 pb-0 h-6 mt-1">
              <input
                name="showLoadMore"
                checked={!state.showLoadMore}
                onChange={e => toggleSwitchHandler(e, !state.showLoadMore)}
                type="checkbox"
                id="switch-button"
              />
              <div className="switch-slider btn-yn switch-round" />
            </label>
          </div>
          <div className="mt-1 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-col items-center">
            News layout
            <label className="switch mb-0 pb-0 h-6 mt-1">
              <input
                name="isNews"
                checked={!state.isNews}
                onChange={e => toggleSwitchHandler(e, !state.isNews)}
                type="checkbox"
                id="switch-button"
              />
              <div className="switch-slider btn-yn switch-round" />
            </label>
          </div>
          <div className="mt-1 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-col items-center">
            Single layout
            <label className="switch mb-0 pb-0 h-6 mt-1">
              <input
                name="mustBeSingle"
                checked={!state.mustBeSingle}
                onChange={e => toggleSwitchHandler(e, !state.mustBeSingle)}
                type="checkbox"
                id="switch-button"
              />
              <div className="switch-slider btn-yn switch-round" />
            </label>
          </div>
          <div className="mt-1 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-col items-center">
            Tours layout
            <label className="switch mb-0 pb-0 h-6 mt-1">
              <input
                name="isTours"
                checked={!state.isTours}
                onChange={e => toggleSwitchHandler(e, !state.isTours)}
                type="checkbox"
                id="switch-button"
              />
              <div className="switch-slider btn-yn switch-round" />
            </label>
          </div>
          <div className="mt-1 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-col items-center">
            Show all
            <label className="switch mb-0 pb-0 h-6 mt-1">
              <input
                name="showAll"
                checked={!state.showAll}
                onChange={e => toggleSwitchHandler(e, !state.showAll)}
                type="checkbox"
                id="switch-button"
              />
              <div className="switch-slider btn-yn switch-round" />
            </label>
          </div>
          <div className="mt-1 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-col items-center">
            Scrollable
            <label className="switch mb-0 pb-0 h-6 mt-1">
              <input
                name="scrollable"
                checked={!state.scrollable}
                onChange={e => toggleSwitchHandler(e, !state.scrollable)}
                type="checkbox"
              />
              <div className="switch-slider btn-yn switch-round" />
            </label>
          </div>
          <div className="mt-1 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-col items-center">
            Is full width
            <label className="switch mb-0 pb-0 h-6 mt-1">
              <input
                name="isFullWidth"
                checked={!state.isFullWidth}
                onChange={e => toggleSwitchHandler(e, !state.isFullWidth)}
                type="checkbox"
              />
              <div className="switch-slider btn-yn switch-round" />
            </label>
          </div>
          <div className="my-2 pt-0 ml-4 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular">
            Layout:
              <select name="layout"  onChange={setLimitHandler} value={state.layout} className="ml-1">
              <option value={false} key={'no_layout'}>No</option>
              <option value={"discos"} key={'Records_element'}>Records</option>
              <option value={"curatedList"} key={'curatedList_element'}>Curated list</option>
              <option value={"noticias"} key={'noticias_element'}>News</option>
              <option value={"mainNews"} key={'mainnews_element'}>News Main</option>
              <option value={"smallPictures"} key={'smallPictures_element'}>Small pics</option>
              <option value={"smallPicturesTextInWhite"} key={'smallPicturesTextInWhite_element'}>Small pics-White</option>
            </select>
          </div>
          <div />
        </div>
      </div>
    </div>
  );
};

Launcher2.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
};


export default Launcher2;
